var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agent-corp-mail-page"},[_c('AgentCorpMailManager')],1)}
var staticRenderFns = []

export { render, staticRenderFns }